/// FOURJS_START_COPYRIGHT(D,2020)
/// Property of Four Js*
/// (c) Copyright Four Js 2020, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("BrowserWindowsService", ["InitService"], function (context, cls) {
  /**
   * Service that manages links between browser windows used by sessions
   * @namespace gbc.BrowserWindowsService
   * @gbcService
   * @publicdoc
   */
  class BrowserWindowsService /** @lends gbc.BrowserWindowsService */ {
    constructor() {
      this._eventListener = null;
    }

    /**
     * Initialize the session Service
     */
    init() {
      this._eventListener = new cls.EventListener();
      window.addEventListener("multiWindowUnloadRoot", () => {
        window.close();
      });
    }

    /**
     * @returns {Window}
     */
    isRootWindow() {
      return window._multiWindowData.isRoot;
    }

    /**
     * @returns {gbc}
     */
    getRootGbc() {
      let rootWindow = window._multiWindowData.rootWindow;
      return rootWindow && rootWindow.gbc;
    }

    /**
     * @returns {classes.VMSession}
     */
    getRootSession() {
      let rootGbc = this.getRootGbc();
      return rootGbc && rootGbc.SessionService.getCurrent();
    }

    /**
     * @returns {classes.VMSession}
     */
    getParentSession() {
      let parentWindow = window._multiWindowData.parentWindow;
      let parentGbc = parentWindow && parentWindow.gbc;
      return parentGbc && parentGbc.SessionService.getCurrent();
    }

    /**
     *
     * @returns {number}
     */
    countChildWindows(filter = (w) => true) {
      return window._multiWindowData.directChildren.filter(filter).length;
    }

    /**
     *
     */
    closeAllChildren() {
      if (this.isRootWindow()) {
        let children = window._multiWindowData.directChildren;
        while (children.length) {
          const w = children.pop();
          w.__desactivateEndingPopup = true;
        }
      }
    }
  }

  gbc.BrowserWindowsService = new BrowserWindowsService();
  context.InitService.register(context.BrowserWindowsService);
});
